import React, { useEffect, useState } from "react"
import PropTypes, { array } from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Button,
  Input,
  ModalHeader,
  Modal,
  ModalBody,
  Form,
  Label,
  CardTitle,
} from "reactstrap"
import { withRouter } from "react-router"
import Select from "react-select"
import { Link } from "react-router-dom"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import Switch from "react-switch"
import FileDownload from "js-file-download"
//
const DataTableEnseignant = props => {
  const [loading, setLoading] = useState(false)
  const [arraySelect, setArraySelect] = useState([])
  const [arraySelectAll, setArraySelectAll] = useState([])
  const [actions, setActions] = useState([
    { value: 1, label: "Générer Compte" },
    { value: 2, label: "Suppression" },
  ])
  const [selectAction, setSelectAction] = useState("")
  const [orders, setOrders] = useState([])
  const [modal1, setModal1] = useState(false)
  const [etudiantId, setEtudiantId] = useState("")
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [delet, setDelet] = useState(0)
  const [imp, setImp] = useState(0)
  const [view, setView] = useState(0)
  const [add, setAdd] = useState(0)
  const [cloture, setCloture] = useState(0)
  const [departement, setDepartement] = useState([])
  const [selectDepartement, setSelectDepartement] = useState("")
  const [modalAdd, setModalAdd] = useState(false)
  const [salle, setSalle] = useState([])
  const [selectSalle, setSelectSalle] = useState("")
  const [id, setId] = useState("")
  const [modalUnDemi, setModalUnDemi] = useState(false)
  const [interneExterne, setInterneExterne] = useState(1)
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id

  useEffect(async () => {
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"))
    setCloture(cloture_annee)
    const userAuth = JSON.parse(localStorage.getItem("UserMenu"))
    const typeArticleSubMenu = userAuth.find(user =>
      user.sous_menu.some(subMenu => subMenu.sous_menu === "Enseignants")
    )
    setDelet(typeArticleSubMenu.sous_menu[0].delete)
    setImp(typeArticleSubMenu.sous_menu[0].imp)
    setView(typeArticleSubMenu.sous_menu[0].view)
    setAdd(typeArticleSubMenu.sous_menu[0].add)
    var userAuthScolarite = JSON.parse(
      localStorage.getItem("userAuthScolarite")
    )
    var annee_id = userAuthScolarite.user.annee_id
    const res = API.post("enseignant/list", {
      annee_id: annee_id,
    }).then(res => {
      setOrders(res.data.enseignants)
      setLoading(true)
    })
    const resDepartement = await API.get("departement/select").then(
      resDepartement => {
        setDepartement(resDepartement.data.Departement)
        setSelectDepartement("")
      }
    )
  }, [])
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Next",
    prePageText: "Back",
    sizePerPage: 30,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }

  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "cin",
      text: "CIN",
      sort: true,
      style: {
        textAlign: "center",
      },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "nom",
      text: (
        <>
          Nom et <br /> prénom
        </>
      ),
      sort: true,
      style: {
        textAlign: "center",
      },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "nom_ar",
      text: (
        <>
          Nom et <br /> prénom arabe
        </>
      ),
      sort: true,
      style: {
        textAlign: "center",
      },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "grade",
      text: "Grade",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "chef_departement_name", // obligatoire si isDummyField
      text: (
        <>
          Chef <br /> département
        </>
      ),
      isDummyField: true,
      sort: true,
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),

      // eslint-disable-next-line react/display-name
      formatter: (cell, row) => {
        const value = row.chef_departement_name;
        if (!value) return "";

        // Séparer les noms par virgule
        const chefs = String(value)
          .split(",")
          .map(v => v.trim())
          .filter(Boolean);

        // Remplacer le "[" par "\n[" pour forcer un retour à la ligne
        const lignes = chefs.map(v => v.replace(/\s*\[/, "\n["));

        return (
          <div style={{ textAlign: "center", whiteSpace: "pre-line" }}>
            {lignes.map((ligne, index) => (
              <div key={index}>{ligne}</div>
            ))}
          </div>
        );
      }
    },
    {
      dataField: "Groupes",
      isDummyField: true,
      text: "Groupes",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        view === 1 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Link to={"/EnseignantsGroupes?id=" + row.id}>
              <i
                style={{ color: "darkmagenta", cursor: "pointer" }}
                className="fas fa-users-cog"
              ></i>
            </Link>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#A7A3A3", cursor: "pointer" }}
              className="fas fa-users-cog"
              title="Vous n'avez pas le droit "
            ></i>
          </div>
        ),
    },
    {
      dataField: "Fiche pédagogique",
      text: (
        <>
          Fiche <br /> pédagogique
        </>
      ),
      isDummyField: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        view === 1 ? (
          row.count != 0 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Link to={"/FicheVoeux?id=" + row.id}>
                <i
                  style={{ color: "darkorange", cursor: "pointer" }}
                  className="fas fa-clipboard-list"
                ></i>
              </Link>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#A7A3A3", cursor: "pointer" }}
                className="fas fa-clipboard-list"
                title="Aucun fiche de voeux"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#A7A3A3", cursor: "pointer" }}
              className="fas fa-clipboard-list"
              title="Vous n'avez pas le droit de fiche de voeux"
            ></i>
          </div>
        ),
    },
    {
      dataField: "Exploration",
      isDummyField: true,
      text: "Exploration",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        view === 1 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Link to={"/DetailEnseignants?id=" + row.id}>
              <i
                style={{ color: "darkcyan", cursor: "pointer" }}
                className="fas fa-eye"
              ></i>
            </Link>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#A7A3A3", cursor: "pointer" }}
              className="fas fa-eye"
              title="Vous n'avez pas le droit de fiche de voeux"
            ></i>
          </div>
        ),
    },
    {
      dataField: "Compte",
      isDummyField: true,
      text: "Compte",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture != 1 ? (
          delet === 1 ? (
            row.is_compte == -1 ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <i
                  style={{ color: "blueviolet", cursor: "pointer" }}
                  className="fas fa-user-plus"
                  onClick={() => addAccount(row)}
                ></i>
              </div>
            ) : row.is_compte == 1 && row.active_compte == 0 ? (
              <div
                onClick={() => toggle1(row)}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <i
                  style={{ color: "red", cursor: "pointer" }}
                  className="fas fa-user"
                ></i>
              </div>
            ) : (
              <div
                onClick={() => toggle1(row)}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <i
                  style={{ color: "#34c38f", cursor: "pointer" }}
                  className="fas fa-user"
                ></i>
              </div>
            )
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#A7A3A3", cursor: "pointer" }}
                className="fas fa-user"
                title="Vous n'avez pas le droit de fiche de voeux"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#A7A3A3", cursor: "pointer" }}
              className="fas fa-user"
              title="Année clôturée"
            ></i>
          </div>
        ),
    },
    // {
    //   dataField: "Affecté une salle spécifique",
    //   text: (
    //     <>
    //       Affecté une <br /> salle spécifique
    //     </>
    //   ),
    //   isDummyField: true,
    //   style: { textAlign: "center" },
    //   headerStyle: (colum, colIndex) => {
    //     return { textAlign: "center" }
    //   },
    //   sort: true,
    //   // eslint-disable-next-line react/display-name
    //   formatter: (cellContent, row) =>
    //     cloture !== 1 ? (
    //       add === 1 ? (
    //         row.salle_name === 0 ? (
    //           <div style={{ display: "flex", justifyContent: "center" }}>
    //             <i
    //               style={{ color: "#999f15", cursor: "pointer" }}
    //               onClick={() => toggleAdd(row.id)}
    //               className="fas fa-door-open"
    //               title={"Affecté une salle spécifique"}
    //             ></i>
    //           </div>
    //         ) : (
    //           <p
    //             title={"Effectuez un double-clic pour modifier la salle"}
    //             onDoubleClick={() => toggleAdd(row.id)}
    //           >
    //             {row.salle_name}
    //           </p>
    //         )
    //       ) : (
    //         <div style={{ display: "flex", justifyContent: "center" }}>
    //           <i
    //             style={{ color: "#A7A3A3", cursor: "pointer" }}
    //             className="fas fa-door-open"
    //             title="Vouz n'avez pas d'accées"
    //           ></i>
    //         </div>
    //       )
    //     ) : (
    //       <div style={{ display: "flex", justifyContent: "center" }}>
    //         <i
    //           style={{ color: "#A7A3A3", cursor: "pointer" }}
    //           className="fas fa-door-open"
    //           title="Année clôturée"
    //         ></i>
    //       </div>
    //     ),
    // },
    {
      dataField: "Affecté une salle spécifique",
      text: (
        <>
          Affecté une <br /> salle spécifique
        </>
      ),
      isDummyField: true,
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture !== 1 ? (
          add === 1 ? (
            row.salle_name === 0 ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <i
                  style={{ color: "#999f15", cursor: "pointer" }}
                  onClick={() => toggleAdd(row.id)}
                  className="fas fa-door-open"
                  title="Affecté une salle spécifique"
                ></i>
              </div>
            ) : (
              <p
                title="Effectuez un double-clic pour modifier la salle"
                onDoubleClick={() => toggleAdd(row.id)}
                style={{ margin: 0 }}
              >
                {formatSalleName(row.salle_name, 5)}
              </p>
            )
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#A7A3A3", cursor: "pointer" }}
                className="fas fa-door-open"
                title="Vous n'avez pas d'accès"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#A7A3A3", cursor: "pointer" }}
              className="fas fa-door-open"
              title="Année clôturée"
            ></i>
          </div>
        ),
    },

    {
      dataField: "Interne",
      isDummyField: true,
      text: (
        <>
         Interne<br /> Externe
        </>
      ),
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture !== 1 ? (
          add === 1 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{
                  color: "#5E065270",
                  cursor: "pointer",
                  fontSize: "15px",
                }}
                onClick={() => toggleUnDemi(row.id)}
                className="fas fa-sign-out-alt "
                title="Interne / Externe"
              ></i>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{
                  color: "#A7A3A3",
                  cursor: "pointer",
                  fontSize: "15px",
                }}
                className="fas fa-sign-out-alt "
                title="Vouz n'avez pas d'accées"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#A7A3A3", cursor: "pointer", fontSize: "15px" }}
              className="fas fa-sign-out-alt "
              title="Année clôturée"
            ></i>
          </div>
        ),
    },
    {
      dataField: "active",
      isDummyField: true,
      text: "Etat",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (colIndex, row) =>
        cloture != 1 ? (
          add === 1 ? (
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              className="me-1 mb-sm-8 mb-2"
              onColor="#34c38f"
              onChange={() => activeEnseignant(row)}
              checked={row.active}
            />
          ) : (
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              className="me-1 mb-sm-8 mb-2"
              onColor="#34c38f"
              onChange={() => activeEnseignant(row)}
              checked={row.active}
              disabled={true}
              readOnly={true}
            />
          )
        ) : (
          <Switch
            uncheckedIcon={<Offsymbol />}
            checkedIcon={<OnSymbol />}
            className="me-1 mb-sm-8 mb-2"
            onColor="#34c38f"
            checked={row.active}
            disabled={true}
            readOnly={true}
          />
        ),
    },
  ]
  const formatSalleName = (salleName, chunkSize = 5) => {
    if (!salleName || typeof salleName !== "string") return salleName;

    const salles = salleName.split(",").map(s => s.trim());
    const chunks = [];

    for (let i = 0; i < salles.length; i += chunkSize) {
      chunks.push(salles.slice(i, i + chunkSize));
    }

    return (
      <>
        {chunks.map((group, index) => (
          <span key={index}>
          {group.join(", ")}
            <br />
        </span>
        ))}
      </>
    );
  };

  const toggleUnDemi = id => {
    setModalUnDemi(!modalUnDemi)
    setId(id)
    setInterneExterne(1)
  }
  const toggleAdd = id => {
    setModalAdd(!modalAdd)
    setId(id)
    API.get("salle/select").then(resSalle => {
      setSalle(resSalle.data.Salle)
    })
  }
  const toggleAddSalle = async () => {
    setLoading(false)
    const res = await API.post("enseignant/getsalle", {
      enseignant_id: id,
      salle_id: selectSalle,
      user_id,
      annee_id,
    }).then(res => {
      if(res.data.errNum === 409 || res.data.errNum ==="409"){
        toast.error(res.data.msg, { containerId: "A"})
        return
      }
      setModalAdd(false)
      API.post("enseignant/list", {
        annee_id: annee_id,
      }).then(res => {
        setOrders(res.data.enseignants)
        setLoading(true)
      })
    })
  }
  const Offsymbol = () => {
    return (
      <div
        title="Activé"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        A
      </div>
    )
  }

  const OnSymbol = props => {
    return (
      <div
        title="Désactivé"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        D
      </div>
    )
  }

  const { SearchBar } = Search

  // Select All Button operation
  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        var array = arraySelect
        array.push(row)
        setArraySelect(array)
        let tab = [...arraySelectAll]
        tab.push(row)
        setArraySelectAll(tab)
      } else {
        var array = arraySelect
        array.splice(rowIndex, 1)
        setArraySelect(array)
        if (arraySelectAll.length != 0) {
          let tab = [...arraySelectAll]
          let etudId = row.id
          for (let index = 0; index < tab.length; index++) {
            let idEtud = tab[index].id
            if (idEtud == etudId) {
              tab.splice(index, 1)
              setArraySelectAll(tab)
              break
            }
          }
        }
      }
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        var array = arraySelectAll
        for (let i = 0; i < orders.length; i++) {
          array.push(orders[i])
        }
        setArraySelectAll(array)
      } else {
        setArraySelectAll([])
      }
    },
  }

  const action = async () => {
    setLoading(true)
    if (selectAction == "") {
      toast.error(" Voulez-vous choisir Générer Compte ou Suppression Compte", {
        containerId: "A",
      })
    } else {
      if (selectAction.value == 1) {
        if (arraySelectAll.length != 0) {
          var enseignants = arraySelectAll
        } else {
          var enseignants = arraySelect
        }
        const res = await API.post("user/generate_accounts", {
          enseignants: enseignants,
        }).then(res => {
          toast.success(" Les Comptes Générés Successfully ", {
            containerId: "A",
          })
          const resE = API.get("User/list_id_enseignant").then(resE => {
            const res = API.post("enseignant/list", {
              comptes: resE.data.comptes,
            }).then(res => {
              setOrders(res.data.enseignants)
            })
          })
        })
      } else if (selectAction.value == 2) {
        if (arraySelectAll.length != 0) {
          var enseignants = arraySelectAll
        } else {
          var enseignants = arraySelect
        }
        if (localStorage.getItem("userAuthScolarite")) {
          var userAuthScolarite = JSON.parse(
            localStorage.getItem("userAuthScolarite")
          )
          var user_id = userAuthScolarite.user.id
        }
        const resD = await API.post("enseignant/deletes", {
          enseignants: enseignants,
          user_id: user_id,
          annee_id,
        }).then(resD => {
          const resE = API.get("User/list_id_enseignant").then(resE => {
            const res = API.post("enseignant/list", {
              comptes: resE.data.comptes,
            }).then(res => {
              toast.success("Les Comptes Supprimés Successfully ", {
                containerId: "A",
              })
              setOrders(res.data.enseignants)
              setLoading(true)
            })
          })
          setArraySelectAll([])
        })
      }
    }
  }

  const activeEnseignant = async row => {
    var active = row.active
    var enseignant_id = row.id
    if (active == 0) {
      const res = await API.post("enseignant/activer_enseignant", {
        id: enseignant_id,
        user_id,
        annee_id,
      }).then(res => {
        toast.success(" 🔓✔️ Compte Activé avec Successfully", {
          containerId: "A",
        })
        API.post("enseignant/list", {
          annee_id: annee_id,
        }).then(res => {
          setOrders(res.data.enseignants)
          setLoading(true)
        })
      })
    } else if (active == 1) {
      const res = await API.post("enseignant/desactiver", {
        id: enseignant_id,
        user_id,
        annee_id,
      }).then(res => {
        toast.success(" 🔓✔️ Compte desactivé avec Successfully", {
          containerId: "A",
        })
        API.post("enseignant/list", {
          annee_id: annee_id,
        }).then(res => {
          setOrders(res.data.enseignants)
          setLoading(true)
        })
      })
    }
  }

  const addAccount = async row => {
    var enseignants = row
    const res = await API.post("User/create", {
      enseignants: enseignants,
    }).then(res => {
      toast.success("Compte Ajouté Successfully ", {
        containerId: "A",
      })
      const resE = API.get("User/list_id_enseignant").then(resE => {
        const res = API.post("enseignant/list", {
          comptes: resE.data.comptes,
        }).then(res => {
          setOrders(res.data.enseignants)
        })
      })
    })
  }

  const toggle2 = async row => {
    setModal1(!modal1)
  }

  const toggle1 = async row => {
    setModal1(!modal1)
    setName(row.nom)
    setEmail(row.email)
    setEtudiantId(row)
  }

  const edit = async etudiantId => {
    var id = etudiantId.id
    const res = await API.post("enseignant/update_password", {
      id: id,
      email: email,
      password: password,
      user_id,
      annee_id,
    }).then(res => {
      setModal1(false)
    })
  }

  const activate = async etudiantId => {
    var id = etudiantId.id
    var active = etudiantId.active_compte
    if (active == 0) {
      var active = 1
      const res = await API.post("user/activate", {
        id: id,
        active: active,
        annee_id,
        user_id,
      }).then(res => {
        setModal1(false)
        toast.success(" 🔓✔️ Compte Activé Successfully", {
          containerId: "A",
        })
        const resE = API.get("User/list_id_enseignant").then(resE => {
          const res = API.post("enseignant/list", {
            comptes: resE.data.comptes,
          }).then(res => {
            setOrders(res.data.enseignants)
          })
        })
      })
    } else if (active == 1) {
      var active = 0
      const res = await API.post("user/activate", {
        id: id,
        active: active,
        user_id,
        annee_id,
      }).then(res => {
        setModal1(false)
        toast.success(" 🔒❌ Compte Désactivé Successfully", {
          containerId: "A",
        })
        const resE = API.get("User/list_id_enseignant").then(resE => {
          const res = API.post("enseignant/list", {
            comptes: resE.data.comptes,
          }).then(res => {
            setOrders(res.data.enseignants)
          })
        })
      })
    }
  }
  const search = async () => {
    const departement_id =
      selectDepartement != "" && selectDepartement != null
        ? selectDepartement.value
        : 0

    setOrders([])
    const res = await API.post("enseignant/get_by_departement", {
      departement_id: departement_id,
      annee_id,
    }).then(res => {
      setOrders(res.data.enseignants)
    })
  }
  const searchAll = async () => {
    const res = await API.post("enseignant/list", {
      annee_id: annee_id,
    }).then(res => {
      setOrders(res.data.enseignants)
      setLoading(true)
    })
  }
  const toggleAddAnnuler = async () => {
    setLoading(false)
    const res = await API.post("enseignant/annuler_affectation_salle_enseignant", {
      enseignant_id: id,
      user_id,
      annee_id,
    }).then(res => {
      setModalAdd(false)
      const resD = API.post("enseignant/list",{annee_id}).then(resD => {
        setOrders(resD.data.enseignants)
        setLoading(true)
      })
    })
  }
  const toggleInterneExterne = async () => {
    setLoading(false)
    const res = await API.post("enseignant/update_interne_externe", {
      enseignant_id: id,
      option: interneExterne,
      user_id,
      annee_id,
    }).then(res => {
      setModalUnDemi(false)
      const resD = API.post("enseignant/list",{annee_id}).then(resD => {
        setOrders(resD.data.enseignants)
        setLoading(true)
      })

    })
  }
  return (
    <React.Fragment>
      <div>
          <Row className="mt-4">
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={orders}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <div>
                    <CardTitle style={{ color: "#556ee6" }} className="h4">
                      Critères de Recherches
                    </CardTitle>

                    <Form className="mt-4">
                      <Row>
                        <Col lg="4">
                          <div className="mb-2">
                            <Label>Département :</Label>
                            <Select
                              options={departement}
                              isSearchable
                              isClearable
                              value={selectDepartement}
                              onChange={setSelectDepartement}
                            />
                          </div>
                        </Col>

                        <Col lg="8">
                          <div className="mb-3 row">
                            <Label>Générer Compte / Suppression Compte :</Label>

                            <Col md="6">
                              <Select
                                options={actions}
                                isSearchable
                                value={selectAction}
                                onChange={setSelectAction}
                                placeholder="Actions"
                              />
                            </Col>

                            <Col md="2">
                              <Button
                                type="button"
                                color="primary"
                                className="w-100"
                                onClick={action}
                              >
                                Appliquer
                              </Button>
                            </Col>

                            <Col md="3">
                              <a
                                href="https://scolarite.flshs.edura.backcresus-institut.ovh/api/impression_list_enseignants"
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-primary w-100"
                              >
                                <i className="fas fa-file-download me-2"></i>
                                Liste Enseignant
                              </a>
                            </Col>
                          </div>
                        </Col>
                      </Row>
                    </Form>

                    {/* Boutons recherche */}
                    <Row className="mb-4 text-center">
                      <Col lg="6">
                        <Button
                          style={{ backgroundColor: "#761C19", borderColor: "#761C19" }}
                          className="mb-2 me-2"
                          onClick={search}
                        >
                          Rechercher
                        </Button>
                      </Col>

                      <Col lg="6">
                        <Button
                          style={{ backgroundColor: "#761C19", borderColor: "#761C19" }}
                          className="mb-2 me-2"
                          onClick={searchAll}
                        >
                          Afficher tout
                        </Button>
                      </Col>
                    </Row>

                    {/* TABLE / LOADING */}
                    {loading ? (
                      <>
                        <div className="mb-3 row">
                          <Col md="6">
                            <div className="search-box">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                        </div>
                        <BootstrapTable
                          wrapperClasses="table-responsive"
                          noDataIndication={() => <NoDataIndication />}
                          striped={false}
                          selectRow={selectRow}
                          bordered={false}
                          classes={"table align-middle table-nowrap"}
                          headerWrapperClasses={"table-light"}
                          rowStyle={(row, rowIndex) => {
                            if (row.externe === 1) {
                              return { backgroundColor: "#c7efef" } // vert clair
                            }
                            return {} // aucune couleur sinon
                          }}
                          hover
                          pagination={paginationFactory(pageOptions)}
                          {...toolkitProps.baseProps}
                        />
                        {/*<BootstrapTable*/}
                        {/*  wrapperClasses="table-responsive"*/}
                        {/*  noDataIndication={() => <NoDataIndication />}*/}
                        {/*  striped={false}*/}
                        {/*  bordered={false}*/}
                        {/*  selectRow={selectRow}*/}
                        {/*  classes="table align-middle table-nowrap"*/}
                        {/*  headerWrapperClasses="table-light"*/}
                        {/*  hover*/}
                        {/*  pagination={paginationFactory(pageOptions)}*/}
                        {/*  {...toolkitProps.baseProps}*/}
                        {/*/>*/}
                      </>
                    ) : (
                      <div className="text-center mt-4">
                        <Spinner type="grow" color="primary" />
                        <h4 className="mt-3">En cours ...</h4>
                      </div>
                    )}
                  </div>
                  )}
                  </ToolkitProvider>
            </Col>
          </Row>
      </div>
      <Modal isOpen={modal1} toggle={toggle2} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle2}
          tag="h4"
        >
          {name}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Form>
              <Row>
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">Email</Label>
                    <Input
                      lg="3"
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                    />
                  </div>
                </Col>
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">Password</Label>
                    <Input
                      lg="3"
                      type="password"
                      className="form-control"
                      placeholder="Password"
                      onChange={e => setPassword(e.target.value)}
                    />
                  </div>
                </Col>
              </Row>
            </Form>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <div lg="4">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                  className="text-center mt-4"
                >
                  {etudiantId.active_compte == 0 ? (
                    <Button
                      type="button"
                      color="success"
                      className="btn btn-primary  mb-2 me-2"
                      onClick={() => activate(etudiantId)}
                    >
                      Activer
                    </Button>
                  ) : (
                    <Button
                      type="button"
                      color="danger"
                      className="btn btn-primary  mb-2 me-2"
                      onClick={() => activate(etudiantId)}
                    >
                      Desactiver
                    </Button>
                  )}
                </div>
              </div>
              <di lg="4">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                  className="text-center mt-4"
                >
                  <Button
                    type="button"
                    color="warning"
                    className="btn btn-warning  mb-2 me-2"
                    onClick={toggle2}
                  >
                    Annuler
                  </Button>
                </div>
              </di>
              <div lg="4">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                  className="text-center mt-4"
                >
                  <button
                    type="button"
                    className="btn btn-primary "
                    onClick={() => edit(etudiantId)}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </Row>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalAdd} toggle={toggleAdd} centered={true}>
        <ModalHeader
          style={{width: "100% !important", textAlign: "center !important"}}
          toggle={toggleAdd}
          tag="h4">
          {"Affectation une salle spécifique"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >

            <Row>
              <Col md={12}>
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">Salle:</Label>
                  <Select
                    options={salle}
                    isSearchable={true}
                    isMulti={true}
                    onChange={e => setSelectSalle(e)}

                  />
                </div>
              </Col>
            </Row>


            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleAddSalle}
                >
                  <i
                    style={{color: "white"}}
                    className="far fa-thumbs-up"
                  ></i>
                  Confirmer
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleAddAnnuler}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {"Annuler l'affectation de salle"}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalUnDemi} toggle={toggleUnDemi} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleUnDemi}
          tag="h4"
        >
          {"Interne / Externe"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <Row>
              <Col
                md={12}
                style={{ marginBottom: "30px", textAlign: "center" }}
              >
                <div className="mb-12">
                  <Label className="d-block mb-3">
                    {/*{"Interne"} :*/}
                  </Label>
                  <div className="form-check form-check-inline">
                    <Input
                      type="radio"
                      id="customRadioInline1"
                      name="customRadioInline1"
                      className="form-check-input"
                      checked={interneExterne === 1}
                      onChange={e => setInterneExterne(1)}
                    />
                    <Label
                      className="form-check-label"
                      htmlFor="customRadioInline1"
                    >
                      Externe
                    </Label>
                  </div>
                  &nbsp;
                  <div className="form-check form-check-inline">
                    <Input
                      type="radio"
                      id="customRadioInline2"
                      name="customRadioInline1"
                      className="form-check-input"
                      checked={interneExterne === 0}
                      onChange={e => setInterneExterne(0)}
                    />
                    <Label
                      className="form-check-label"
                      htmlFor="customRadioInline2"
                    >
                      Interne
                    </Label>
                  </div>
                </div>
              </Col>
            </Row>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleInterneExterne}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Confirmer
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleInterneExterne}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {"Annuler l'opérartion de l'affectation"}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withRouter(DataTableEnseignant)
DataTableEnseignant.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
}
